import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import AuthenticationFirewallDashboard, {
    AuthenticationFirewallBlockPage,
    useAuthenticationFirewallEnabled
} from '../../modules/authenticationFirewall';

export const AuthenticationFirewallDashboardRouting = (props: LogicalRouteImportProps) => {
    const enabledByPricingModules = useAuthenticationFirewallEnabled();

    return (
        <LogicalRoute
            {...props}
            component={AuthenticationFirewallDashboard}
            blockPageComponent={AuthenticationFirewallBlockPage}
            displayBlockPage={!enabledByPricingModules}
        />
    );
};
